import React from 'react';
import ServicesPhoto from '@/images/portrush/portrush_services.jpg';

const OurServiceSection = () => {
  return (
    <div className="bg-[#F8F9FB] text-center lg:text-left px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-16 w-full">
      <div className="flex flex-col lg:flex-row justify-between items-center mx-auto">
        <div className="lg:w-1/2 lg:pr-8 mb-8">
          <p className="text-[20px] font-semibold text-[#1C2938] mb-5">
            Three lucky golfers will win a trip for two to play Ireland’s
            most iconic courses.
          </p>
          <p className="text-gray-600 text-lg mb-5">
            Imagine you and a friend playing 6 days of golf at the
            most iconic courses on the Emerald Isle. That dream will
            come true for 3 lucky winners of our Dream Ireland Golf
            Getaway package, in partnership with All Access GTE.
          </p>
          <p>
            <button
              className="w-full sm:w-auto px-11 py-3 bg-[#49C44F] text-white font-medium
              text-medium rounded-full relative"
              onClick={() => window.location.href = '/ireland-dreamgolfgetaway-terms'}
            >
              Click here to view the full terms and conditions.
            </button>
            {' '}
          </p>
        </div>
        <div className="
          sm:flex-shrink-0 flex flex-col items-center justify-center text-center lg:w-1/2
        ">
          <img
            src={ServicesPhoto}
            alt="ShipSticks Logo"
            className="w-full rounded-[25px]"
          />
        </div>
      </div>
    </div>
  );
};

export default OurServiceSection;
